/**
 * Next's image optimiser rejects private-IP absolute URLs. Payload can store
 * the current dev origin in media rows, so turn only that same-origin media
 * endpoint into a relative URL and let the browser resolve it locally.
 */
export function normaliseMediaSrc<T>(src: T, siteOrigin: string): T | string {
  if (typeof src !== 'string' || !/^https?:\/\//i.test(src)) return src

  try {
    const origin = new URL(siteOrigin)
    const url = new URL(src)
    if (
      url.origin !== origin.origin ||
      url.username ||
      url.password ||
      !/^\/api\/media\/file\/[^/]+/.test(url.pathname)
    ) {
      return src
    }
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return src
  }
}
